module.exports = __webpack_public_path__ + "media/img/why/setmeeting-833709ed4ea5a82e6435e1894457a478.png";